/* ============================================================
   /pages/i-miei-preferiti — render della grid leggendo gli item
   denormalizzati dal localStorage (window.zcWishlist).
   Nessuna fetch verso Shopify: tutti i dati delle card (title,
   url, image, price) sono salvati al momento dell'add sul PDP.
   Limitazione MVP: se un prodotto è stato aggiornato/eliminato
   in admin, la card mostra il dato stale fino al re-save.
   ============================================================ */
(function () {
  'use strict';

  if (!window.zcWishlist) return;

  const container = document.querySelector('[data-zc-preferiti]');
  if (!container) return;

  const loadingEl = container.querySelector('[data-zc-preferiti-loading]');
  const emptyEl = container.querySelector('[data-zc-preferiti-empty]');
  const gridEl = container.querySelector('[data-zc-preferiti-grid]');

  if (!emptyEl || !gridEl) return;

  // --- Format helpers --------------------------------------------------

  function formatMoney(cents) {
    if (cents == null) return '';
    // Default Italian formatting: € 29,99 (Shopify cents → human).
    const value = (cents / 100).toFixed(2).replace('.', ',');
    return '€ ' + value;
  }

  function escapeHTML(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // --- Render ----------------------------------------------------------

  function renderItem(item) {
    const li = document.createElement('li');
    li.className = 'zc-preferiti__item';
    li.dataset.productId = item.id;

    const url = item.url || '#';
    const title = escapeHTML(item.title || 'Prodotto');
    const image = item.image || '';
    const priceHTML = item.price != null
      ? '<span class="zc-preferiti__price">' +
          formatMoney(item.price) +
          (item.compare_at_price && item.compare_at_price > item.price
            ? '<span class="zc-preferiti__price-compare">' + formatMoney(item.compare_at_price) + '</span>'
            : '') +
        '</span>'
      : '';

    li.innerHTML =
      '<button type="button" class="zc-preferiti__remove" aria-label="Rimuovi ' + title + ' dai preferiti" data-zc-preferiti-remove="' + escapeHTML(item.id) + '">' +
        '<svg viewBox="0 0 20 20" aria-hidden="true">' +
          '<path d="M5 5 L15 15 M15 5 L5 15"/>' +
        '</svg>' +
      '</button>' +
      '<a class="zc-preferiti__media" href="' + escapeHTML(url) + '">' +
        (image
          ? '<img src="' + escapeHTML(image) + '" alt="' + title + '" loading="lazy" width="600" height="600">'
          : '<div style="display:grid;place-items:center;width:100%;height:100%;font-size:48px;opacity:0.5;">🐾</div>') +
      '</a>' +
      '<div class="zc-preferiti__body">' +
        '<h3 class="zc-preferiti__title"><a href="' + escapeHTML(url) + '">' + title + '</a></h3>' +
        priceHTML +
      '</div>';

    return li;
  }

  function render() {
    const items = window.zcWishlist.getAll();

    if (loadingEl) loadingEl.setAttribute('hidden', '');

    if (items.length === 0) {
      emptyEl.removeAttribute('hidden');
      gridEl.setAttribute('hidden', '');
      gridEl.innerHTML = '';
      return;
    }

    emptyEl.setAttribute('hidden', '');
    gridEl.removeAttribute('hidden');
    gridEl.innerHTML = '';
    items.forEach((item) => {
      gridEl.appendChild(renderItem(item));
    });
  }

  // --- Remove handler --------------------------------------------------

  gridEl.addEventListener('click', (event) => {
    const btn = event.target.closest('[data-zc-preferiti-remove]');
    if (!btn) return;
    event.preventDefault();
    const id = btn.dataset.zcPreferitiRemove;
    const item = btn.closest('.zc-preferiti__item');
    if (!item) return;
    // Animate out, then remove from storage (which triggers re-render
    // via the zc:wishlist:remove event listener below).
    item.classList.add('is-removing');
    setTimeout(() => {
      window.zcWishlist.remove(id);
    }, 200);
  });

  // --- Wire up ---------------------------------------------------------

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }

  // Re-render quando la wishlist cambia (es. utente apre un'altra tab,
  // rimuove altrove, oppure il toast remove del modulo viene chiamato).
  window.addEventListener('zc:wishlist:add', render);
  window.addEventListener('zc:wishlist:remove', render);
})();
